/**
 * 政府公屋
 * 
 * @Author: Focci
 * @Date: 2023-07-10 10:13:27
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-10 10:13:27
 */

import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { pick } from 'lodash-es'
import Markers from './Markers'

export default function StateHouseMarker({
  apiParam = null,
  ...markerProps
}) {
  const fetchParam = useMemo(
    () => ({ ...pick(apiParam, ['type', 'rect', 'aggPoints', 'listCurrentPage']), stateHouse: 1 }), 
    [apiParam]
  )
  
  return (
    <Markers
      needGroup
      url="map/valuation"
      param={fetchParam}
      type="stateHouse"
      markerStyle={{ zIndex: 3 }}
      researchAlwaysOnMove
      {...markerProps}
    />
  )
}

StateHouseMarker.propTypes = {
  apiParam: PropTypes.object,
}
